import {useState, useMemo} from 'react';
import {useTranslation} from 'react-i18next';
import {LinkOption} from './useLinkOptions';

interface UseLinkSelectStateProps {
    linkValue: string;
    allOptions: LinkOption[];
}

export function useLinkSelectState({linkValue, allOptions}: UseLinkSelectStateProps) {
    const {t} = useTranslation('realtime');
    const layoutT = useTranslation('layout');
    
    const selectedOption = useMemo(
        () => allOptions.find(opt => opt.path === linkValue),
        [allOptions, linkValue]
    );
    
    const isCustom = !selectedOption && !!linkValue;
    const [forceCustom, setForceCustom] = useState(false);
    const showCustomInput = isCustom || forceCustom;

    const displayText = showCustomInput 
        ? (layoutT.t('custom')) 
        : (selectedOption?.label || t('link'));

    return {
        selectedOption,
        isCustom,
        forceCustom,
        setForceCustom,
        showCustomInput,
        displayText
    };
}
